<template>
  <Modal nome="esqueceuSenha">
    <Campo tipo="email" placeholder="email@email.com" completar="email" label="E-mail da sua conta" v-model="state.email" />
    <BotaoPrincipal nome="Recuperar Senha" @click="salvar" />
  </Modal>
</template>

<script setup>
import { reactive, inject, onMounted } from 'vue'
import { useStoreModal } from '@stores'
import Modal from '@components/global/modal/Modal.vue'
import BotaoPrincipal from '@components/global/elementos/BotaoPrincipal.vue'
import Campo from '@components/global/elementos/Campo.vue'

const emitter = inject('emitter')
const storeModal = useStoreModal()

const state = reactive({
  email: ''
})

function validarDados() {
  let mensagem
  if (!state.email) {
    mensagem = 'Preencha o e-mail da sua conta'
  } else {
    return true
  }

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem })
}

async function salvar() {
  if (!validarDados()) return

  storeModal.fecharModal('esqueceuSenha')
}

function limparCampos() {
  state.email = ''
}

onMounted(() => {
  emitter.on('limparCampos', limparCampos)
})
</script>

<style scoped>
button {
  margin: 20px 0 0 0;
}
/* Responsivo */
@media screen and (max-width: 1024px) {
}
</style>
